import axios from "axios"
import api from "../../../../utilidades/interceptor";

const urlApi = process.env.REACT_APP_API_KEY

export const getSalidas = (setState)=>
{
    api.get(`${urlApi}/administracion/visitas/getusuarios`).then((res)=>
    {
        console.log("res.data.data",res.data);
        setState(res.data)
    })
    .catch((error)=>
    {
        console.log("error",error);   
    })
}
export const finalizarUsuario=(id,setData)=>
{
    api.post(`${urlApi}/administracion/visitas/finalizarusuario?id_operador=${id}`).then((res)=>{
        getSalidas(setData)
    })
    .catch((error)=>
    {
        console.log("error",error);
    })
}
